import { Button, Group, Modal, Pagination, Radio, Space, Table, TextInput } from '@mantine/core';
import { useRef, useState } from 'react';

import useGetModems from '../../../../../../shared/hook/useGetModems';
import type { IModem } from '../../../../../../shared/types/modem';

interface IModemListModalProps {
  opened: boolean;
  onClose: () => void;
  onSelectModem: (modem: IModem) => void;
}

export default function ModemListModal(props: IModemListModalProps) {
  const { opened, onClose, onSelectModem } = props;
  const [page, setPage] = useState(1);
  const [keyword, setKeyword] = useState('');
  const [selectedModemId, setSelectedModemId] = useState<number | null>(null);
  const searchInputRef = useRef<HTMLInputElement>(null);

  const { data: modemList } = useGetModems({
    pg: page,
    pgSize: 10,
    keyword,
    listType: 'UNUSED',
  });

  const modemItems = modemList?.list ?? [];

  const handleSearch = () => {
    setKeyword(searchInputRef.current?.value ?? '');
    setPage(1);
    setSelectedModemId(null);
  };

  const handleChangePage = (nextPage: number) => {
    setPage(nextPage);
    setSelectedModemId(null);
  };

  const handleSelect = () => {
    const selectedModem = modemItems.find((item) => item.id === selectedModemId);

    if (!selectedModem) {
      return;
    }

    onSelectModem(selectedModem);
    onClose();
  };

  const handleClose = () => {
    setPage(1);
    setKeyword('');
    setSelectedModemId(null);
    if (searchInputRef.current) {
      searchInputRef.current.value = '';
    }
    onClose();
  };

  return (
    <Modal centered opened={opened} onClose={handleClose} title="연결할 단말기 선택" size="lg">
      <Group>
        <TextInput
          ref={searchInputRef}
          placeholder="단말기 일련번호 입력"
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              e.preventDefault();
              handleSearch();
            }
          }}
        />
        <Button type="button" onClick={handleSearch}>
          검색
        </Button>
      </Group>
      <Table mt="md">
        <Table.Thead>
          <Table.Tr>
            <Table.Th>선택</Table.Th>
            <Table.Th>모뎀/라우터</Table.Th>
            <Table.Th>단말기 일련번호</Table.Th>
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody>
          {modemItems.map((item) => (
            <Table.Tr key={item.id}>
              <Table.Td>
                <Radio checked={selectedModemId === item.id} onChange={() => setSelectedModemId(item.id)} />
              </Table.Td>
              <Table.Td>{item.modem}</Table.Td>
              <Table.Td>{item.modemNo}</Table.Td>
            </Table.Tr>
          ))}
        </Table.Tbody>
      </Table>
      <Group justify="center" mt="xs">
        <Pagination total={Math.ceil((modemList?.totalCount ?? 0) / 10)} value={page} onChange={handleChangePage} />
      </Group>
      <Space h={36} />
      <Group justify="center">
        <Button variant="default" onClick={handleClose}>
          취소
        </Button>
        <Button type="button" variant="filled" color="secondary.5" onClick={handleSelect} disabled={selectedModemId === null}>
          확인
        </Button>
      </Group>
    </Modal>
  );
}
